var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritesCountIIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.718,
    height: 24.715,
    viewBox: "0 0 19.718 24.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1359",
    d: "M0-682.665H19.718v24.715H0Z",
    transform: "translate(0 680.166)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1357",
    transform: "translate(0 2.499)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1363",
    transform: "translate(3.053 0.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1365",
    d: "M-41.608,0a1.238,1.238,0,0,0-.876.363,1.237,1.237,0,0,0-.362.875V17.717a.845.845,0,0,0,.845.846h0a.937.937,0,0,0,.665-.277c.82-.819,3.239-3.239,4.238-4.236a1.489,1.489,0,0,1,1.055-.437,1.489,1.489,0,0,1,1.055.437c1,1,3.434,3.432,4.245,4.243a.919.919,0,0,0,.65.269.857.857,0,0,0,.857-.856V1.237a1.237,1.237,0,0,0-.362-.875A1.238,1.238,0,0,0-30.47,0Z",
    transform: "translate(42.845)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesCountIIcon);
export default __webpack_public_path__ + "static/media/favorites_CountI_Icon.64fe9ca92a9ce34614e62f3ab2bd081e.svg";
export { ForwardRef as ReactComponent };